import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $insertNodes, $createTextNode } from 'lexical';
import React, { useEffect } from 'react';
import { MentionNode } from './MentionNode';

function MentionPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const unregister = editor.registerCommand(
      'insert-mention',
      (payload) => {
        editor.update(() => {
          const mentionNode = new MentionNode(payload);
          $insertNodes([mentionNode, $createTextNode(' ')]);
        });
        return true;
      },
      0
    );

    return () => unregister();
  }, [editor]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === '@') {
        editor.update(() => {
          const selection = $getSelection();
          if (!selection) return;

          const mentionList = ['Lea', 'Tom', 'Cyndi'];

          const popup = document.createElement('div');
          popup.className = 'mention-popup';

          mentionList.forEach((name) => {
            const item = document.createElement('div');
            item.className = 'mention-item';
            item.textContent = name;
            item.onclick = () => {
              editor.dispatchCommand('insert-mention', name);
              popup.remove();
            };
            popup.appendChild(item);
          });

          const range = window.getSelection().getRangeAt(0).getBoundingClientRect();
          popup.style.position = 'absolute';
          popup.style.top = `${range.bottom + window.scrollY}px`;
          popup.style.left = `${range.left + window.scrollX}px`;
          popup.style.background = '#fff';
          popup.style.border = '1px solid #ccc';
          popup.style.padding = '4px';
          popup.style.borderRadius = '4px';
          popup.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';

          document.body.appendChild(popup);
        });
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [editor]);

  return null;
}

export default MentionPlugin;
